export function viewTransactionType(data, transactionType) {
  let newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (
      transactionType.includes('B/S') &&
      element.transactionTypes?.includes('B') &&
      element.transactionTypes?.includes('S')
    ) {
      newData.push(element);
      continue;
    }

    if (
      transactionType.includes('B') &&
      element.transactionTypes?.includes('B') &&
      !element.transactionTypes?.includes('S')
    ) {
      newData.push(element);
      continue;
    }

    if (
      transactionType.includes('S') &&
      element.transactionTypes?.includes('S') &&
      !element.transactionTypes?.includes('B')
    ) {
      newData.push(element);
      continue;
    }
  }

  return [...newData];
}
